import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../assets/styles/media';
import THEME from '../../assets/styles/config';

interface SlaProps {
  primaryColor?: string;
  secondaryColor?: string;
  width?: number;
}

export const Background = styled.div<SlaProps>`
  border-radius: 40px;
  height: 40px;

  ${(props): SimpleInterpolation =>
    css`
      width: ${props.width}%;
      background-color: ${props.secondaryColor};
    `};
`;

export const ContentCtn = styled.div<SlaProps>`
  position: absolute;
  > svg {
    margin: 0 10px;
    ${(props): SimpleInterpolation =>
      css`
        stroke: ${props.primaryColor};
      `}
  }

  > span {
    font-weight: bold;
    font-size: 16px;

    ${Media.Below.desktop`
      font-size: 14px;
    `}

    ${(props): SimpleInterpolation =>
      css`
        color: ${props.primaryColor};
      `}
  }
`;

export const JobCount = styled.div`
  color: ${THEME.colors.secondaryFontColor};
  font-size: 16px;
  min-width: 30px;
  text-align: end;

  ${Media.Below.desktop`
    font-size: 12px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 14px;
  `}
`;

export const SlaGraphCtn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 95%;
  position: relative;
  margin: 20px 0;

  ${Media.Below.tablet`
      height: 35px;
      margin: 10px 0;
    `}
`;

// Stands where the count will be until it arrives. The same pale shape the report cards use for their pending numbers, so
// a placeholder looks the same wherever it appears.
export const PendingCount = styled.span`
  display: inline-block;
  width: 24px;
  height: 12px;
  vertical-align: middle;
  border-radius: 6px;
  background: #f0f2f5;
`;
